
namespace Gamification.Gamification {
    export class ApiOperazioniColumns {
        static columnsKey = 'Gamification.ApiOperazioni';
    }
}